import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import Payments from './Loadable';

function Card({ payments, isLoading, pingState })
{
    return (
        <CollapsibleCard
            pingState={pingState}
            title="Traveler Payments"
            storeId="booking_payments"
        >
            <Payments
                payments={payments}
                isLoading={isLoading}
            />
        </CollapsibleCard>
    );
}

Card.defaultProps = {
    pingState: false,
    isLoading: false,
};

Card.propTypes = {
    payments: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        Type: PropTypes.string,
        Item: PropTypes.string,
        Paid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        'Due/Payment Date': PropTypes.string,
        'Balance Due': PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        currencyCode: PropTypes.string,
        isTotal: PropTypes.bool,
    })).isRequired,
    pingState: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default Card;
